import { useEffect, useState } from "react";
import { Toolbar, useGetList } from "react-admin";
import { Button, Box, Card, CircularProgress, Typography, Divider } from "@mui/material";
import { Cancel as CancelIcon, Save as SaveIcon } from "@mui/icons-material";
import BulkFlagInput from "./BulkFlagInput";

const ClientChartBulkForm = ({ onSave, onCancel, onError, setSelectedSeries }) => {
    const { data, isLoading, isError, isSuccess, error } = useGetList("portal/chartSeries");

    const [choices, setChoices] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (isError) {
            console.error(error);
            onError();
        }
    }, [isError]);

    useEffect(() => {
        if (!isLoading && isSuccess && !isError) {
            setChoices(
                data.map((s) => `${s.Subchart.name}: ${s.name != null ? s.name : s.alias && s.alias} [${s.id}]`)
            );
        }
    }, [isLoading, isSuccess]);

    return (
        (isLoading && (
            <Box>
                <CircularProgress />
            </Box>
        )) ||
        (!isLoading && isSuccess && (
            <Card>
                <Typography margin={2} variant="h6">
                    Settings
                </Typography>

                <Divider />

                <Box mb={2} ml={1} mr={2}>
                    <BulkFlagInput
                        type="autocomplete"
                        label="Chart Series"
                        value={selected}
                        onChange={(newValue) => {
                            setSelectedSeries(
                                newValue.map((item) => Number(item.substring(item.indexOf("[") + 1, item.length - 1)))
                            );
                            setSelected(newValue);
                        }}
                        options={choices}
                        alertText="The selected Chart Series will be ADDED to the selected Client Chart configs"
                    />
                </Box>

                <Toolbar>
                    <Button
                        disabled={selected.length === 0}
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                    <Box ml={2} />
                    <Button variant="contained" startIcon={<CancelIcon />} onClick={onCancel}>
                        Cancel
                    </Button>
                </Toolbar>
            </Card>
        ))
    );
};

export default ClientChartBulkForm;
